var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPuppy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M6.144 11.244A4 4 0 0 1 7.55 11c3.314 0 6.073 3.595 6.939 9.464l.074.503c.25 1.679.487 3.263.487 5.033 0 3.396-3.116 6-7.5 6s-6.5-2.604-6.5-6c0-1.77.236-3.354.486-5.033l.075-.503c.376-2.55.92-4.67 1.688-6.252.456-2.638.919-4.04 1.9-5.445C6.699 6.617 9.9 5 13.925 5c4.623 0 9.262.952 10.689 4.645.82 2.123 1.34 2.029 2.576 2.188.661.085 1.204-.08 2.091.167 1.182.33 1.68 1.085 1.669 2-.114 7.475-.686 12-5.9 12h-7v-2h7c2.666 0 2.979-2.13 3.445-5.306.109-.745.293-1.526.293-2.278-1.104 0-2.238-.311-2.238-1.416v-1.321l-.035-.016-.097-.006c-2.304-.44-2.568-.657-3.214-2.204C21.819 6.55 17.093 7 13.149 6.995c-4.04.404-5.91 1.45-7.005 4.25M7.55 30c3.178 0 5.5-1.627 5.5-4 0-1.643-.22-3.112-.452-4.658l-.088-.586C11.787 15.855 9.39 13 7.55 13s-3.237 2.855-3.96 7.756l-.088.586C3.27 22.888 3.05 24.357 3.05 26c0 2.373 1.322 4 4.5 4",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M19.05 16a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
})));
export default SvgPuppy;